import React, { useState } from "react";
import style from "../../../styles/mystyle.module.css";
import PhoneCode from "../PhoneCode/PhoneCode";
import Change from "./Change";
// import { printLogs } from "../../helpers/helpers";
import { Navbar } from '../Layout/Navbar'
// import { TextField, Button, Container } from "@mui/material";
import { useTranslation } from "next-i18next";
import { Grid } from "@mui/material";
import config from "../../../next.config.js";
// import LoadingButton from "@mui/lab/LoadingButton";
import Stack from "@mui/material/Stack";
// import { styled } from "@mui/system";
import AlertDialog from '../../components/Dialogs/AlertDialog'
import axios from "axios";
import {Customebtn , CustomeForm} from '../StyledComponent/Login.style'
function WhiteForget() {
  const [forgetPasswordData, setForgetPassData] = React.useState({
    showVerficationCode: true
  });
  const [codeCallBackData, setCodeCallBackData] = React.useState({
    showResetPassword: false
  });
  const [loading, setLoading] = React.useState(false);
  function handleClick() {
    setLoading(true);
  }
  const [inputList, setInputList] = useState({
    mobile: "",
    index: 0,
    errorArray: [{ mobile: false, message: "هذا الحقل إجباري" }]
  });
  const handleInputChange = e => {
    const { name, value } = e.target;
    const list = { ...inputList };
    list[name] = value;
    handleError(list, name);
    setInputList(list);
  };
  const [responseMessgae, setResponseMessage] = React.useState({ type: null, message: null, show: false })
  const resetFormFunc = event => {

    event.preventDefault();
  
    if (handleError(inputList, "mobile")) {
      axios
        .post(
          `${config["basePath"]}/api/user/forgetPassword`,
          { data: { userName: inputList.mobile } },
          {
            headers: {
              "Content-Type": "application/json",
              ["accept-language"]: "ar"
            }
          }
        )
        .then(function (response) {
          if (response.data.data.success == true) {
            setForgetPassData(  {...forgetPasswordData,
              showVerficationCode: false})
            setCodeCallBackData({ mobile: inputList.mobile, showVerficationCode: true })
            setInputList({
              mobile: "",
              index: 0,
              errorArray: [{ mobile: false, message: "هذا الحقل إجباري" }]
            });
          }
          else {
            responseMessgae["show"] = true
            responseMessgae["type"] = "error"
            responseMessgae["message"] = response.data.data.subErrors[0].message
            setResponseMessage({ ...responseMessgae })
          }
        })
        .catch(function (error) {

        });
    } else {
      handleError({ ...inputList }, "mobile");
      setInputList({ ...inputList });
    }
  };
  const handleError = (varInput, name) => {
    let formIsValid = true;
    if (name == "mobile") {
      if (varInput.mobile != "") {
        let exp = new RegExp(/^7[0173][0-9]{7}$/gm);
        let val = exp.test(varInput.mobile);
        if (!val) {
          varInput.errorArray[0].mobile = true;
          varInput.errorArray[0].message = "الرقم غير صحيح";
          formIsValid = false;
        } else {
          varInput.errorArray[0].mobile = false;
        }
      } else {
        varInput.errorArray[0].mobile = true;
        formIsValid = false;
      }
      return formIsValid;
    }
  };
  const { t } = useTranslation("common");
  return (
    <div className={style.ContainerMargin} style={{ backgroundColor: "white" }}>

      <Navbar showDownloadAppSection={true} exchangeAllCurrenciesCallBack={(res) => (res)} currenciesCallBack={(res) => (res)}>
        {(forgetPasswordData && forgetPasswordData.showVerficationCode==false) ==
          false ? (
            <div className={style.SectionContainer}>
              <div className={style.allcard}>
                <div className={style.cardLogin}>
                  <div className={style.card1}>
                    <form onSubmit={resetFormFunc}>
                      <div className={style.card3}>
                        <div className={style.HeaderLogin}> {t("ForgetPassWord")} </div>
                        <p className={style.EnterEmail}>{t("EnterPhoneNumber")}</p>
                        <br />
                        <Grid container spacing={2} style={{ paddingBottom: '10px', margin: 0, width: "100%" }}>
                          <Grid
                            className="griditem"
                            item
                            lg={12}
                            xl={12}
                            sm={12}
                            md={12}
                            xs={12}
                            sx={{ paddingBottom: "10px" }}
                          >

                            <CustomeForm

                              className="textfield"
                              label={t("phoneNumber")}
                              id="mobile"
                              name="mobile"
                              size="medium"
                              /*   inputProps={{className:classes.multilineColor}} */
                              error={inputList.errorArray[0].mobile}
                              // className="textfield"
                              onChange={e => handleInputChange(e)}
                              variant="outlined"

                              helperText={
                                inputList.errorArray[0].mobile
                                  ? inputList.errorArray[0].message
                                  : null
                              }
                            />
                          </Grid>
                          <Grid className="griditem" item lg={12} xl={12} sm={12} md={12} xs={12} sx={{ paddingBottom: '10px' }} >
                            <div className={style.EnterEmail + " " + style.TealColor}> {t("notice_forget")} {" "}
                              <a href="" className={style.TealColor} onClick={(e) => { e.preventDefault(), 
                                setCodeCallBackData({ mobile: inputList.mobile, showVerficationCode: true, showMobile: true}) 
                                setForgetPassData({
                                  ...forgetPasswordData,
                                  showVerficationCode: false
                                });
                                }}>{t("EntertheCode")}</a></div>
                          </Grid>
                          <Grid
                            className="griditem"
                            item
                            lg={12}
                            xl={12}
                            sm={12}
                            md={12}
                            xs={12}
                    
                          >
                            <Stack direction="row" spacing={2}>
                              <Customebtn
                                loading={loading}
                                loadingPosition="start"
                                sx={{ color: "white" }}
                                variant="outlined"
                                type={"submit"}
                              >
                                {t("Send")}
                              </Customebtn>{" "}
                           
                            </Stack>
                          </Grid>
                     
                        </Grid>
                      </div>
                    </form>
                  </div>
                  <div className={style.card1}>
                    <img
                      className={style.loginimg}
                      src={`${config.basePath}/assest/Group 6032.svg`}
                    />
                  </div>
                </div>
              </div>
              <AlertDialog open={responseMessgae.show} text={responseMessgae.message}
                type={responseMessgae.type}
                btnOk={() => {
                responseMessgae["show"] = false, setResponseMessage({ ...responseMessgae })

                  // router.push("/")
                }}
              />
            </div>
          ) : (
            ""
          )}
         
         {codeCallBackData.showVerficationCode ? (
          <PhoneCode
            callBackData={codeCallBackData}
            callBackToResetPassword={data => {
              // console.log("data==========>",data)
              setCodeCallBackData({ ...data, ...forgetPasswordData,mobile:codeCallBackData.mobile });
              setForgetPassData({
                ...forgetPasswordData,
                showVerficationCode: false
              });
            }}
          />
       ) : ("")} 
       {/* {console.log("codeCallBackData==========>",codeCallBackData)} */}
        {codeCallBackData.showResetPassword == true ? (<Change codeCallBackData={codeCallBackData} />) : ("")}
      </Navbar>
    </div>
  );
}

export default WhiteForget;
